var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { UserSubject, UserSubjectStatusEnum } from '@/models/UserSubject';
import SelectFilter from '@/components/select-filter/SelectFilter';
import LoadFailed from '@/views/Errors/LoadFailed';
import { Student } from '@/models/Student';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { sortByKey } from '@/support/Object';
import { hex2rgba, formatDate } from '@/support/String';
import AlertCard from '@/components/alert-card/AlertCard';
import Chat from '@/components/chat/Chat';
import EnvironmentSelect from '@/components/environment-select/EnvironmentSelect';
import { whiteKidIcons, whiteAreaIcons } from '@/support/Icon';
import SubjectStatusSelect from '@/components/subject-status-select/SubjectStatusSelect';
import Storage from '@/support/Storage';
import { Template } from '@/models/Template';
import CreateIdpDialog from '@/components/curriculum/CreateIdpDialog';
import DownloadIdpDialog from '@/components/curriculum/DownloadIdpDialog/DownloadIdpDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { Period } from '@/models/Period';
import EditSubjectDialog from '@/components/curriculum/EditSubjectDialog';
import { Year } from '@/models/Year';
import Rating from '@/components/rating/Rating';
import { excludeRoles } from '@/support/ExcludeRoles';
import { debounce, isArray, isEmpty, isEqual, uniq } from 'lodash';
import { Group } from '@/models/Group';
import { GroupSubject } from '@/models/GroupSubject';
import ProgressSelect from '@/components/progress-select/ProgressSelect';
import AbstractUrl from '@/support/AbstractUrl';
import { Project } from '@/models/Project';
import TrafficLight from '@/components/TrafficLight/TrafficLight';
import { RolesEnum } from '@/items/Roles';
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import RemoveLdpDialog from './RemoveLdpDialog/RemoveLdpDialog';
import GoalsetSelect from '../GoalsetSelect/GoalsetSelect';
let Curriculum = class Curriculum extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.currentPeriod = null;
        this.expanded = {};
        this.fileInput = null;
        this.filters = {};
        this.internalFilters = {};
        this.futurePeriod = null;
        this.isAchieved = false;
        this.isEditing = false;
        this.isLoading = false;
        this.isLoadingTopic = {};
        this.isTemplateFile = false;
        this.loadedTopics = {};
        this.periodFilter = { type: 'Period', value: '' };
        this.selectedFile = null;
        this.selectedLevel = { value: null };
        this.selectedPeriod = { value: null };
        this.selectedSubjectLabels = { value: null };
        this.selectedProfileLevels = [];
        this.selectedProject = null;
        this.selectedStatuses = {};
        this.selectedSubject = null;
        this.selectedTemplate = null;
        this.isFilteredOnGoalset = false;
        this.showAddSubjectDialog = false;
        this.showCreatingIdp = false;
        this.showDownloadIdp = false;
        this.showRemoveLdp = false;
        this.showEditSubjectDialog = false;
        this.statuses = [];
        this.student_can_set_goal_to_yellow = true;
        this.subjects = [];
        this.subjectTarget = null;
        this.templates = [];
        this.totalCompleted = 0;
        this.totalCount = 0;
        this.totals = {};
        this.visible = {};
        this.isUpdatingStatus = false;
        this.debounceInitialize = debounce(this.initialize, 300);
        this.RolesEnum = RolesEnum;
        this.isEditingTreatment = false;
        this.selectedStudentId = '';
        this.treatmentLabels = [];
    }
    // Getters
    get userProjects() {
        return (this.student && this.student.projects) || [];
    }
    get icons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    get dialogOptions() {
        const subject = this.selectedSubject;
        return {
            title: subject.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.subject') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!subject) {
                            return;
                        }
                        this.updateStatus(subject, 'inactive');
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSubject = null;
                    },
                },
            },
        };
    }
    get percentageColor() {
        if (this.percentComplete === 0) {
            return 'grey';
        }
        if (this.percentComplete < 33) {
            return 'orange';
        }
        if (this.percentComplete >= 33 && this.percentComplete <= 66) {
            return 'yellow';
        }
        return 'green';
    }
    get percentComplete() {
        if (this.totalCount === 0) {
            return 0;
        }
        const percentage = Math.round((this.totalCompleted / this.totalCount) * 100);
        return percentage;
    }
    get priorityLabel() {
        const setting = this.getSetting('priority_subjects_label');
        return (setting && setting.value) || 'MijnVoorrang';
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    get isUserTeacher() {
        return !!this.$store.state.Auth.isTeacher;
    }
    get canSeeGreenTraficLight() {
        return !!this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.ROOT, RolesEnum.RESELLER]);
    }
    get isTrafficLightDisabled() {
        return this.isUpdatingStatus;
    }
    mounted() {
        if (this.$route.query && !isEmpty(this.$route.query)) {
            this.filters = this.correctFilters(this.$route.query);
            this.$nextTick(() => {
                this.preFillSelects();
            });
        }
        this.preFillStatus();
        this.debounceInitialize();
        this.setSettings();
        this.treatmentLabels = this.student && this.student.treatment_labels
            ? [...this.student.treatment_labels]
            : [];
    }
    get canSeeSubjectOverview() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.MANAGER,
            RolesEnum.RESELLER,
            RolesEnum.SUPERVISOR,
            RolesEnum.BOARD,
            RolesEnum.TEACHER,
        ]);
    }
    correctFilters(queryFilters) {
        const filters = { ...queryFilters };
        if (filters.levels && !isArray(filters.levels)) {
            filters.levels = [filters.levels];
        }
        if (filters.periods && !isArray(filters.periods)) {
            filters.periods = [filters.periods];
        }
        return filters;
    }
    preFillSelects() {
        if (this.filters.levels && this.$refs.levelSelect) {
            this.$refs.levelSelect.setSelected(this.filters.levels);
        }
        if (this.filters.periods) {
            this.$refs.periodSelect.setSelected(this.filters.periods);
        }
        if (this.filters.subject_labels) {
            this.$refs.subjectLabelSelect.setSelected(this.filters.subject_labels);
        }
        if (this.type !== 'group') {
            if (this.filters.project) {
                this.selectedProject = this.findProject((this.filters.project));
            }
        }
    }
    setSettings() {
        if (this.$store.state.Auth.isStudent) {
            const studentCanEditGoalToYellow = this.$store.state.settings.find((setting) => setting.key === 'student_can_set_goal_to_yellow');
            if (studentCanEditGoalToYellow) {
                this.student_can_set_goal_to_yellow = studentCanEditGoalToYellow.value === '1' || studentCanEditGoalToYellow.value === true ? true : false;
            }
        }
    }
    preFillStatus() {
        if (this.future || this.dismissed) {
            this.setStatusFilters();
            return;
        }
        if (this.filters.statuses) {
            this.selectedStatuses = {
                highlighted: this.filters.statuses.includes('highlighted'),
                busy: this.filters.statuses.includes('busy'),
                old: this.filters.statuses.includes('old'),
                closed: this.filters.statuses.includes('closed'),
                finished: this.filters.statuses.includes('finished'),
            };
            return;
        }
        if (this.isVersion('4')) {
            this.selectedStatuses = {
                highlighted: true,
                busy: false,
                old: false,
                closed: false,
                finished: false,
            };
        }
        else {
            this.selectedStatuses = {
                highlighted: true,
                busy: true,
                old: true,
                closed: false,
                finished: false,
            };
        }
        Object.keys(this.selectedStatuses).forEach((key) => {
            this.$set(this.selectedStatuses, key, this.selectedStatuses[key]);
        });
        this.setStatusFilters();
    }
    onClickOpenTreatmentDialog(userId) {
        this.selectedStudentId = userId;
        this.isEditingTreatment = true;
    }
    handleTreatmentSaved(treatmentLabels) {
        this.treatmentLabels = treatmentLabels;
        this.isEditingTreatment = false;
    }
    async initialize() {
        this.isLoading = true;
        this.subjects = [];
        this.totals = {};
        this.totalCount = 0;
        this.totalCompleted = 0;
        if (this.$route.query && this.$route.query.project) {
            this.selectedProject = this.$route.query.project;
        }
        if (this.type === 'student') {
            await this.fetchUserSubjects();
        }
        if (this.type === 'group') {
            await this.fetchGroupSubjects();
        }
        const areas = this.curriculum.subjects || [];
        const visible = {};
        const expanded = {};
        const totals = {};
        let totalCount = 0;
        let totalCompleted = 0;
        areas.forEach((area) => {
            let count = 0;
            const topics = area.children || [];
            topics.forEach((topic) => {
                const subjects = this.subjectsForTopic(topic.id || '');
                count = count + subjects.length;
                visible[topic.id] = false;
                expanded[topic.id] = false;
                totals[topic.id] = subjects.length;
                visible[topic.id] = subjects.length > 0;
                subjects.forEach((subject, index) => {
                    if (subject.status === 'finished') {
                        totalCompleted++;
                    }
                });
            });
            visible[area.id] = count > 0;
            totals[area.id] = count;
            totalCount = totalCount + count;
        });
        this.visible = visible;
        this.expanded = { ...expanded, ...this.expanded };
        this.totals = totals;
        this.totalCount = totalCount;
        this.totalCompleted = totalCompleted;
        this.isLoading = false;
        if (!this.$store.state.year) {
            this.fetchYear();
        }
        else {
            this.fetchPeriods();
        }
    }
    async fetchUserSubjects() {
        await new UserSubject()
            .filter(this.filters)
            .include(['level', 'parent', 'period', 'projects', 'subject_labels'])
            .user(this.student)
            .limit(2000)
            .all()
            .then((subjects) => {
            subjects.sort(sortByKey('name')).forEach((subject, index) => {
                this.$set(subject, 'isVisible', true);
                if (!this.future && subject.status === 'future') {
                    subject.isVisible = false;
                }
                if (!this.dismissed && subject.status === 'dismissed') {
                    subject.isVisible = false;
                }
            });
            this.subjects = subjects;
            if (this.$route.query.subject) {
                new UserSubject()
                    .user(this.student.id || '')
                    .filter('id', this.$route.query.subject)
                    .first()
                    .then((userSubject) => {
                    this.showSubjectDialog(userSubject, true);
                })
                    .catch((error) => {
                    ErrorHandler.network(error);
                });
            }
        });
    }
    async fetchGroupSubjects() {
        if (!this.group) {
            return;
        }
        if (!this.group.id) {
            return;
        }
        const filters = {};
        if (this.group && this.group.projects && this.group.projects.length > 0 && this.isFilteredOnGoalset) {
            filters.projects = this.group.projects.map((project) => project.id || '');
        }
        if (this.group && this.group.projects && this.group.projects.length > 0 && !this.isFilteredOnGoalset) {
            filters.projects = [];
        }
        if (this.filters && this.filters.levels) {
            filters.levels = this.filters.levels;
        }
        if (this.filters && this.filters.periods) {
            filters.periods = this.filters.periods;
        }
        if (this.filters && this.filters.subject_labels) {
            filters.subject_labels = this.filters.subject_labels;
        }
        if (this.filters && this.filters.student_profile_levels) {
            filters.student_profile_levels = this.filters.student_profile_levels;
        }
        await new GroupSubject()
            .filter(filters)
            .group(this.group.id)
            .include(['level', 'parent', 'period', 'subject_labels'])
            .all()
            .then((subjects) => {
            subjects.sort(sortByKey('name')).forEach((subject, index) => {
                this.$set(subject, 'isVisible', true);
                if (!this.future && subject.status === 'future') {
                    subject.isVisible = false;
                }
                if (!this.dismissed && subject.status === 'dismissed') {
                    subject.isVisible = false;
                }
            });
            this.subjects = subjects;
        });
    }
    async toggleAllSubjectStatus(topicId) {
        this.expanded[topicId] = true;
        if (this.loadedTopics[topicId]) {
            return;
        }
        this.$set(this.isLoadingTopic, topicId, true);
        const subjects = this.subjectsForTopic(topicId);
        for (const subject of subjects) {
            this.$refs[`statusCount-${subject.id}`][0].displaySummary();
        }
        for (let index = 0; index < subjects.length; index++) {
            const subject = subjects[index];
            await this.$refs[`statusCount-${subject.id}`][0].showSubjectSummary();
        }
        this.$set(this.isLoadingTopic, topicId, false);
        this.$set(this.loadedTopics, topicId, true);
    }
    setInvisible() {
        this.subjects.sort(sortByKey('name')).forEach((subject, index) => {
            this.$set(subject, 'isVisible', true);
            if (!this.future && subject.status === 'future') {
                subject.isVisible = false;
            }
            if (!this.dismissed && subject.status === 'dismissed') {
                subject.isVisible = false;
            }
            if (subject.status === 'inactive') {
                subject.isVisible = false;
            }
        });
    }
    find(data, key, value) {
        const indexes = [];
        const index = -1;
        const subjects = [];
        data.forEach((item, index) => {
            if (item.parent[key] === value) {
                indexes.push(index);
                subjects.push(this.subjects[index]);
            }
        });
        return subjects;
    }
    fetchYear() {
        new Year()
            .include('periods')
            .current()
            .then((year) => {
            this.$store.dispatch('loadedCurrentYear', year);
            this.fetchPeriods();
        })
            .catch(() => { });
    }
    fetchPeriods() {
        new Period()
            .filter('years', this.$store.state.year.id)
            .all()
            .then((periods) => {
            let futureIndex = -1;
            periods.forEach((period, index) => {
                if (period.is_current) {
                    this.currentPeriod = period;
                    futureIndex = index + 1;
                }
                if (futureIndex === index) {
                    this.futurePeriod = period;
                }
            });
        });
    }
    async updateStatus(subject, status, meta = {}, topicId = null) {
        this.isUpdatingStatus = true;
        this.isLoading = true;
        const userSubjects = await new UserSubject()
            .user(this.student)
            .put([
            {
                ...meta,
                ...{
                    subject: subject.subject,
                    status,
                },
            },
        ]);
        this.isLoading = false;
        if (userSubjects) {
            subject.status = status;
            this.parseSubjectDescription(subject.id || '', topicId, userSubjects);
            this.setInvisible();
        }
        if (this.selectedFile) {
            const collection = status === 'finished' ? status : 'default';
            const file = this.isTemplateFile ? this.selectedFile.links.download : this.selectedFile;
            subject.uploadFile([{ file, collection }]).then((response) => {
                this.$set(subject.files, collection, response.data);
            });
            this.selectedFile = null;
        }
        this.isUpdatingStatus = false;
    }
    onSubjectUpdated(payload) {
        if (!this.subjectTarget || !this.subjectTarget.parent) {
            return;
        }
        const subjects = this.subjectsForTopic(this.subjectTarget.parent.id);
        const subject = subjects.find((subject) => subject.id === this.subjectTarget.id);
        if (!subject) {
            return;
        }
        if ('description' in payload) {
            subject.description = payload.description;
        }
        if ('has_priority' in payload) {
            subject.has_priority = payload.has_priority;
        }
    }
    subjectsForTopic(topicId) {
        return this.find(this.subjects, 'id', topicId);
    }
    totalTopicsForArea(areaId) {
        const areas = this.curriculum.subjects || [];
        const areaIndex = areas.findIndex((area) => area.id === areaId);
        const area = areas[areaIndex];
        const topics = area.children || [];
        return topics.filter((area) => this.visible[area.id]).length;
    }
    onClickFilterByPriority() {
        this.filters.has_priority = !this.filters.has_priority
            ? true
            : undefined;
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
    totalSubjectsForArea(area) {
        if (!area.id) {
            return;
        }
        let count = 0;
        const topics = area.children || [];
        topics.forEach((topic) => {
            if (!topic.id) {
                return;
            }
            const subjects = this.subjectsForTopic(topic.id);
            subjects.forEach((subject) => {
                if (subject.isVisible) {
                    count += 1;
                }
            });
        });
        return count;
    }
    onFileChange(event) {
        if (!event.target.files.length || this.subjectTarget === null) {
            return;
        }
        this.fileInput = event.target;
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
    }
    removeSelectedFile() {
        this.selectedFile = null;
        if (this.fileInput) {
            this.fileInput.removeAttribute('value');
            this.fileInput.setAttribute('value', '');
        }
    }
    deleteFile() {
        if (this.subjectTarget && this.subjectTarget.files) {
            this.subjectTarget.files = [];
        }
    }
    subjectStatusClasses(subject) {
        return {
            highlighted: subject.status === 'highlighted',
            busy: subject.status === 'busy',
            old: subject.status === 'old',
            closed: subject.status === 'closed',
            finished: subject.status === 'finished',
        };
    }
    areaBlockStyles(area) {
        const color = area.color || '#000';
        return {
            backgroundColor: color,
        };
    }
    topicRowStyles(area) {
        const color = area.color || '#000';
        const lightColor = hex2rgba(color, 0.3);
        return {
            backgroundColor: `${lightColor}`,
        };
    }
    toggleStatus(status) {
        this.selectedStatuses[status] = !this.selectedStatuses[status];
        if (this.type === 'student') {
            this.setStatusFilters();
        }
        this.debounceInitialize();
    }
    handleSubjectsAdded(future = false) {
        this.debounceInitialize();
    }
    // protected setGroupFilters() {
    //   if (this.future) {
    //     (this.filters as any)['statuses'] = ['future'];
    //     return;
    //   }
    //   if (this.dismissed) {
    //     (this.filters as any)['statuses'] = ['dismissed'];
    //     return;
    //   }
    //   const statusFilters: string[] = [];
    //   Object.keys(this.selectedStatuses).forEach((key) => {
    //     if ((this.selectedStatuses as any)[key]) {
    //       statusFilters.push(key);
    //     }
    //   });
    //   (this.filters as any)['statuses'] = statusFilters;
    // }
    getTemplates(subjectId) {
        new Template()
            .subject(subjectId)
            .include('file')
            .all()
            .then((templates) => {
            this.templates = templates;
        });
    }
    updateSubject(subject) {
        this.selectedSubject = subject;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    handleNewSubject(subjects) {
        this.debounceInitialize();
    }
    levelClassesForSubject(subject) {
        if (this.type === 'group') {
            return {
                ahead: false,
                behind: false,
            };
        }
        if (subject.level === undefined) {
            return {};
        }
        const subjectLevel = subject.level;
        if (this.student.level === undefined) {
            return {};
        }
        const studentLevel = this.student.level;
        return {
            ahead: subjectLevel.sequence > studentLevel.sequence,
            behind: subjectLevel.sequence < studentLevel.sequence,
        };
    }
    formatDate(date) {
        return formatDate(date);
    }
    redirect(area, topic, subject) {
        this.$router.push(`/students/${this.student.id}/portfolio?area=${area.id}&topic=${topic.id}&subject=${subject.subject}`);
    }
    findProject(id) {
        const projectId = id || this.$route.query.project;
        return this.userProjects
            .find((project) => project.id === projectId) || null;
    }
    parseSubjectDescription(subjectId, topicId, userSubjects) {
        if (!topicId) {
            return;
        }
        const userSubject = userSubjects.find((currentUserSubject) => currentUserSubject.id === subjectId);
        if (!userSubject) {
            return;
        }
        const subjects = this.subjectsForTopic(topicId);
        const subject = subjects.find((subject) => subject.id === subjectId);
        if (!subject) {
            return;
        }
        subject.description = userSubject.description || '';
    }
    subjectStatusLabel(status) {
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    setStatusFilters() {
        if (this.future) {
            this.filters.statuses = ['future'];
            return;
        }
        if (this.dismissed) {
            this.filters.statuses = ['dismissed'];
            return;
        }
        const statusFilters = [];
        Object.keys(this.selectedStatuses).forEach((key) => {
            if (this.selectedStatuses[key]) {
                statusFilters.push(key);
            }
        });
        this.filters.statuses = statusFilters;
        this.setQueryParams(this.filters);
    }
    isVersion(version) {
        return version == this.$store.state.version;
    }
    showSubjectDialog(subject, ignoreStatusCheck = false) {
        if (['dismissed', 'future'].includes(subject.status || '') && !ignoreStatusCheck) {
            return;
        }
        this.subjectTarget = subject;
        this.showEditSubjectDialog = true;
        const subjectId = this.subjectTarget.subject || '';
        if (!this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT])) {
            this.getTemplates(subjectId);
        }
    }
    navigateToSubjectWithAreaFilter(area) {
        if (!area.id) {
            return;
        }
        const routeBase = {
            params: { subjectid: area.id },
            query: {
                area: area.id,
                ...this.$route.query && this.$route.query.levels ? { levels: this.$route.query.levels } : {},
                ...this.$route.query && this.$route.query.periods ? { periods: this.$route.query.periods } : {},
                ...this.$route.query && this.$route.query.subject_labels ? { subject_labels: this.$route.query.subject_labels } : {},
                ...this.$route.query && this.$route.query.statuses ? { statuses: this.$route.query.statuses } : {},
                ...this.$route.query && this.$route.query.statuses ? { goalset: this.isFilteredOnGoalset ? 'goalset-only' : 'all-goals' } : {},
            },
        };
        if (this.$route.name === 'students.show') {
            this.$router.push({
                ...routeBase,
                name: 'subject.idp',
                query: {
                    ...routeBase.query,
                    ...this.$route.params && this.$route.params.id ? { user: this.$route.params.id } : {},
                },
            });
            return;
        }
        if (this.$route.name === 'students.group.show') {
            this.$router.push({
                ...routeBase,
                name: 'subject.group.idp',
                query: {
                    ...routeBase.query,
                    ...this.$route.params && this.$route.params.id ? { user: this.$route.params.id } : {},
                },
            });
            return;
        }
        this.$router.push({
            ...routeBase,
            name: 'subject.lvs',
            query: {
                ...routeBase.query,
                ...this.$route.params && this.$route.params.id ? { groups: this.$route.params.id } : {},
            },
        });
    }
    navigateToSubjectWithAreaAndTopicFilter(area, topic) {
        if (!area.id || !topic.id) {
            return;
        }
        this.$router.push({
            name: 'subject.lvs',
            params: { subjectid: topic.id },
            query: {
                area: area.id,
                topic: topic.id,
                ...this.$route.query && this.$route.query.levels ? { levels: this.$route.query.levels } : {},
                ...this.$route.query && this.$route.query.periods ? { periods: this.$route.query.periods } : {},
                ...this.$route.query && this.$route.query.statuses ? { statuses: this.$route.query.statuses } : {},
                ...this.$route.params && this.$route.params.id ? { groups: this.$route.params.id } : {},
            },
        });
    }
    isYellowTrafficLightVisible(subject) {
        return !!(this.type !== 'group'
            && ((subject.status === 'busy' || subject.status === 'old')
                && (this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.ROOT])
                    || (this.$store.state.Auth.hasRole([RolesEnum.STUDENT]) && this.student_can_set_goal_to_yellow))));
    }
    isGreenTrafficLightVisible(subject) {
        return !!(this.canSeeGreenTraficLight && subject.status !== UserSubjectStatusEnum.FINISHED && subject.status !== UserSubjectStatusEnum.OLD);
    }
    getSetting(key) {
        return this.$store.getters.getSetting(key);
    }
    get goalSelectOptions() {
        if (this.group && this.group.projects && this.group.projects.length > 0) {
            return [
                { value: false, label: this.$tc('goalsetSelect.showAll') },
                { value: true, label: this.$tc('goalsetSelect.showGoalsetOnly') },
            ];
        }
        return [
            { value: false, label: this.$tc('goalsetSelect.showAll') },
        ];
    }
    get studentProfileLevels() {
        if (this.group && this.group.users && Array.isArray(this.group.users) && this.group.users.length > 0) {
            const levels = uniq(this.group.users.map((user) => user.level.value).filter((item) => item).sort((a, b) => a - b));
            return levels.map((level) => {
                return {
                    value: level,
                    text: `${this.$tc('grade')} ${level}`,
                };
            });
        }
        else {
            return [];
        }
    }
    async handleTrafficLightChange(subject, status, topicId, event) {
        event.setLoadingStateOn();
        await this.updateStatus(subject, status, {}, topicId)
            .catch(() => {
            event.setLoadingStateOff();
        });
        event.setLoadingStateOff();
    }
    tabChange(changed) {
        if (changed) {
            this.setInvisible();
        }
    }
    studentChange(student) {
        if (student) {
            this.debounceInitialize();
            this.clearQueryParams();
        }
    }
    onSelectedProjectChanged(selectedProject) {
        if (this.isLoading) {
            return;
        }
        if (isEqual(this.filters.projects, (selectedProject && selectedProject.id))) {
            return;
        }
        this.filters = {
            ...this.filters,
        };
        if (!selectedProject) {
            delete this.filters.projects;
        }
        else {
            this.filters.projects = [selectedProject && selectedProject.id];
        }
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
    selectedLevelChanged(selectedLevel) {
        if (isEqual(this.filters.levels, selectedLevel.value)) {
            return;
        }
        this.filters = {
            ...this.filters,
            levels: selectedLevel.value,
        };
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
    selectedPeriodChanged(selectedPeriod) {
        // No change don't call API and update query
        if (isEqual(this.filters.periods, selectedPeriod.value)) {
            return;
        }
        this.filters = {
            ...this.filters,
            periods: selectedPeriod.value,
        };
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
    selectedSubjectLabelsChanged(selectedSubjectLabels) {
        // No change don't call API and update query
        if (isEqual(this.filters.subject_labels, selectedSubjectLabels.value)) {
            return;
        }
        this.filters = {
            ...this.filters,
            subject_labels: selectedSubjectLabels.value,
        };
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
    selectedProfileLevelsChanged(selectedProfileLevels) {
        // No change don't call API and update query
        if (isEqual(this.filters.student_profile_levels, selectedProfileLevels)) {
            return;
        }
        this.filters = {
            ...this.filters,
            student_profile_levels: selectedProfileLevels,
        };
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
    selectedProjectChanged(selectedProject) {
        if (isEqual(this.filters.projects, selectedProject.id)) {
            return;
        }
        this.filters = {
            ...this.filters,
            projects: [selectedProject.id],
        };
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
    selectedGoalsetOnlyChanged() {
        this.setQueryParams(this.filters);
        this.debounceInitialize();
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof CurriculumModel !== "undefined" && CurriculumModel) === "function" ? _a : Object)
], Curriculum.prototype, "curriculum", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], Curriculum.prototype, "dismissed", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], Curriculum.prototype, "future", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Group !== "undefined" && Group) === "function" ? _b : Object)
], Curriculum.prototype, "group", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_c = typeof Student !== "undefined" && Student) === "function" ? _c : Object)
], Curriculum.prototype, "student", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], Curriculum.prototype, "tabChanged", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], Curriculum.prototype, "infoVisible", void 0);
__decorate([
    Prop({ default: 'student' }),
    __metadata("design:type", String)
], Curriculum.prototype, "type", void 0);
__decorate([
    Watch('tabChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "tabChange", null);
__decorate([
    Watch('student'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_d = typeof Student !== "undefined" && Student) === "function" ? _d : Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "studentChange", null);
__decorate([
    Watch('selectedProject'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "onSelectedProjectChanged", null);
__decorate([
    Watch('selectedLevel'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_f = typeof Record !== "undefined" && Record) === "function" ? _f : Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "selectedLevelChanged", null);
__decorate([
    Watch('selectedPeriod'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_g = typeof Record !== "undefined" && Record) === "function" ? _g : Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "selectedPeriodChanged", null);
__decorate([
    Watch('selectedSubjectLabels'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_h = typeof Record !== "undefined" && Record) === "function" ? _h : Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "selectedSubjectLabelsChanged", null);
__decorate([
    Watch('selectedProfileLevels'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "selectedProfileLevelsChanged", null);
__decorate([
    Watch('selectedProject'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_j = typeof Project !== "undefined" && Project) === "function" ? _j : Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "selectedProjectChanged", null);
__decorate([
    Watch('isFilteredOnGoalset'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "selectedGoalsetOnlyChanged", null);
Curriculum = __decorate([
    Component({
        components: {
            AlertCard,
            Chat,
            EnvironmentSelect,
            LoaderCard,
            LoadFailed,
            SelectFilter,
            GoalsetSelect,
            SubjectStatusSelect,
            CreateIdpDialog,
            EditSubjectDialog,
            Rating,
            DownloadIdpDialog,
            ProgressSelect,
            TrafficLight,
            TreatmentDialog,
            RemoveLdpDialog
        },
    })
], Curriculum);
export default Curriculum;
